(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["pickup-banners"]) return;
  try {
    
 (function(){
    var pickSlider;
    if( document.querySelector(".pickupBannersSlideshow") ){
      window.addEventListener('load',function(){
        document.querySelector(".pickup-banners-section").classList.add("is-load");
        let w = window.innerWidth;
        if (w >=1024){
         pickSlider = new Flickity('.pickupBannersSlideshow',{
            pageDots: false,
            prevNextButtons: false,
            resize: true,
            initialIndex: 1,
          }); 
        }else{
          pickSlider = new Flickity('.pickupBannersSlideshow',{
            pageDots: true,
            prevNextButtons: true,
            resize: true,
            initialIndex: 1,
          });
        }  
      });
      window.addEventListener('resize',function(){
        pickSlider.destroy();
         w = window.innerWidth;
        if (w >=1024){
         pickSlider = new Flickity('.pickupBannersSlideshow',{
            pageDots: false,
            prevNextButtons: false,
            resize: true,
            initialIndex: 1,
          }); 
        }else{
          pickSlider = new Flickity('.pickupBannersSlideshow',{
            pageDots: true,
            prevNextButtons: true,
            resize: true,
            initialIndex: 1,
          });
        } 
        pickSlider.resize();
      });
    }
    if( Shopify.designMode ){
      document.querySelector(".pickup-banners-section").classList.add("is-load");
      document.addEventListener('shopify:section:load',function(){
        document.querySelector(".pickup-banners-section").classList.add("is-load");
        let w = window.innerWidth;
        if (w >= 1024) {
          pickSlider = new Flickity('.pickupBannersSlideshow',{
            pageDots: false,
            prevNextButtons: false,
            resize: true,
            initialIndex: 1,
          });
        } else {
          pickSlider = new Flickity('.pickupBannersSlideshow',{
            pageDots: true,
            prevNextButtons: true,
            resize: true,
            initialIndex: 1,
          });
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

})();
